import { keepPreviousData, queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { CASE_ARCHIVE_STATUS_MAP } from '../../../constants'
import { type ReqSearchCasesQuery, type ResSearchCasesQuery } from './types'

export const getSearchCasesQuery = (payload: ReqSearchCasesQuery) => {
  const {
    path_id,
    pageNumber,
    pageSize,
    keyword,
    tagCondition = 'or',
    tags = [],
    processingTimeCondition,
    processingTime = [],
    status = [],
    sort,
    asc,
    archiveStatus = CASE_ARCHIVE_STATUS_MAP.ALL,
  } = payload

  return queryOptions({
    queryKey: [
      API_ENDPOINTS.business.v4.case.search.index,
      {
        path_id,
        pageNumber,
        pageSize,
        keyword,
        tagCondition,
        tags,
        processingTimeCondition,
        processingTime,
        status,
        sort,
        asc,
        archiveStatus,
      },
    ],
    queryFn: (): Promise<ResSearchCasesQuery> => {
      return w
        .post(
          {
            path_id,
            pageNumber,
            pageSize,
            keyword,
            tagCondition,
            tags,
            processingTimeCondition,
            processingTime,
            status,
            sort,
            asc,
            archiveStatus,
          },
          API_ENDPOINTS.business.v4.case.search.index
        )
        .json()
    },
    placeholderData: keepPreviousData,
  })
}
